import { Box, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { CONTAINER_ELEMENT } from '../../lib/config';
import Page from '../Page';

import NetworkStatusIndicator from './NetworkStatusIndicator';
import SkipNavigation from './SkipNavigation';

export interface ContentFrameProps {
  children: React.ReactNode;
  header: FC;
  title?: string;
}

const ContentFrame = ({ children, header: Header, title }: ContentFrameProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Page>
      <Helmet defaultTitle={title} titleTemplate={title ? `%s - ${title}` : '%s'} />
      <SkipNavigation />
      <Box
        id={CONTAINER_ELEMENT}
        sx={{
          '& #start-of-content': {
            flex: 1,
            position: 'relative',
          },
          '& .preloader': {
            backgroundColor: theme.palette.background.default,
            opacity: 1,
            top: 0,
            zIndex: theme.zIndexLoader,
          },
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Header />
        <NetworkStatusIndicator />
        <div id="start-of-content">
          <main role="main">{children}</main>
        </div>
      </Box>
    </Page>
  );
};

export default ContentFrame;
